






import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

@Component({
})
export default class CacheableComponent extends Mixins() {
  @Prop()
  isVisible: boolean;

  data(): any {
    return {
      isCreated: false,
    };
  }
  isCreated: boolean;

  mounted() {
    this.isCreated = this.isCreated || this.isVisible;
  }

  @Watch("isVisible")
  onIsVisibleUpdated(newValue: boolean, oldValue: boolean) {
    this.isCreated = this.isCreated || newValue;
  }
}
